import React, { useEffect, useState } from "react";
import { Images } from "constants/Images";
import InputBox from "components/comman/InputBox";
import "stylesheets/modal.scss";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useForm } from "react-hook-form";
import Button from "components/button";
import { useNavigate } from "react-router-dom";

const schema = yup.object({
  projectName: yup.string().required().label("Project name"),
  location: yup.string().required().label("Location"),
  streetAddress: yup.string().required().label("Street address"),
  city: yup.string().required().label("City"),
  state: yup.string().required().label("State/Region"),
  postalCode: yup.string().required().label("Postal code"),
  country: yup.string().required().label("Country"),
});

const QuotationProjectModal = (props) => {
  const { show, onClose, onSubmit } = props;
  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
  });
  const navigate = useNavigate();
  const handleBtn = (value) => {
    console.log("get Value", value);
    navigate('/createProjectForm', { state: { data: value }})
  };

  console.log("error", errors);
  return (
    <div className={`modal createProject ${show ? "show" : ""}`}>
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header">
            <h2 style={{}}>Create a new project</h2>
            <p className="subtitle">
              Enter project info below. Grease Monkey will reference the
              location and size using local requirements if known.
            </p>
            <button type="button" onClick={onClose} className="btn close">
              <img src={Images.icon.closeCircle1} alt="close" />
            </button>
          </div>
          <div className="modal-body">
            <form onSubmit={handleSubmit(onSubmit)}>
              <InputBox
                name="projectName"
                control={control}
                label="Project Name"
                placeholder="Enter Project Name"
                required
              />

              <InputBox
                name="location"
                control={control}
                label="Location"
                placeholder="Enter Location"
                required
              />

              <div className="address-section">
                <InputBox
                  name="streetAddress"
                  control={control}
                  label="Street Address"
                  placeholder="Enter Street  Address"
                  required
                />

                <InputBox name="city" control={control} label="City" required  placeholder="Enter City"/>

                <InputBox
                  name="state"
                  control={control}
                  label="State/Region"
                  required
                  placeholder="Enter State"
                />

                <div className="form-row">
                  <InputBox
                    name="postalCode"
                    control={control}
                    label="Postal Code"
                    placeholder="Enter Postal Code"
                    required
                  />

                  <InputBox
                    name="country"
                    control={control}
                    label="Country"
                    placeholder="Enter Country"
                    required
                  />
                </div>
              </div>

              <div className="button_group">
                <Button label="CANCEL" white onClick={onClose}/>
                <Button label="CREATE →" onClick={handleSubmit(handleBtn)} />
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};
export default QuotationProjectModal;
